import { render, staticRenderFns } from "./OakNext.vue?vue&type=template&id=daa5a77a&scoped=true"
import script from "./OakNext.vue?vue&type=script&lang=js"
export * from "./OakNext.vue?vue&type=script&lang=js"
import style0 from "./OakNext.vue?vue&type=style&index=0&id=daa5a77a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa5a77a",
  null
  
)

export default component.exports